import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Form} from 'formik';
import LogoMain from '../../../../../common/assets/logo/logo-h-black.svg';
import FieldInput from 'common/components/FieldInput';
import ModalForgotPassword from '../ModalForgotPassword';
import ModalMessage from 'common/components/ModalMessage';
import ContactLogin from "modules/Auth/components/ContactLogin";
import styles from './styles.module.scss';
import TooltipContainer from "../../../../../common/components/TooltipContainer";

const LoginFormView = ({values, onRegisterClick, messageText}) => {
  const [modalContactSlide, setModalContactSlide] = useState(false);
  const slideModalContact = () => {
    setModalContactSlide(!modalContactSlide);
  };

  return (
    <div className={styles.form}>
      <img
        src={LogoMain}
        alt="large_bk"
        className={styles.logoMain}
      />
      <Form className={styles.loginForm}>
        <div className={styles.row}>
          <FieldInput
            fieldId="username"
            type={"text"}
            value={values.username}
            label="שם משתמש (אימייל)"
            showBird={false}
            classNames={{
              input: styles.input,
              label: styles.inputLabel,
            }}
          />
        </div>
        <div className={styles.row}>
          <FieldInput
            fieldId="password"
            type="password"
            peepPassword={true}
            value={values.password}
            label={(
              <>
                <span className={styles.labelMargin}>סיסמה</span>
                <TooltipContainer
                  label={
                    <div>
                      <p>סיסמה צריכה להכיל לפחות 8 תוים</p>
                      <p>סיסמה חייבת להכיל ספרה, אות גדולה ואות קטנה</p>
                    </div>
                  }
                />
              </>
            )}
            showBird={false}
            classNames={{
              input: styles.input,
              label: styles.inputLabel,
            }}
          />
        </div>
        <div className={styles.forgotPasswordAction}>
          <span>שכחתי</span>
          <ModalForgotPassword/>
        </div>
        <button
          type="submit"
          className={styles.buttonSend}
        >
          <span>כניסה</span>
        </button>
        <div className={styles.loginFormActions}>
          <div className={styles.toRegisterAction}>
            לא רשום?<span onClick={onRegisterClick}>לחץ כאן</span>
          </div>
          <div className={styles.contactUsAction} onClick={slideModalContact}>
            צור קשר
          </div>
        </div>
      </Form>
      <ContactLogin
        modalContactSlide={modalContactSlide}
        slideModalContact={slideModalContact}
      />
      <ModalMessage message={messageText}/>
    </div>
  )
};

LoginFormView.propTypes = {
  values: PropTypes.object,
  onRegisterClick: PropTypes.func,
  messageText: PropTypes.string
};

export default LoginFormView;
